import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExtraChargeSubjectModel } from '../../models/ExtraChargeSubjectModel'


export interface ExtraChargeSubjectState {
    ExtraChargeSubject: ExtraChargeSubjectModel
    ExtraChargeSubjectList: ExtraChargeSubjectModel[]
}

const initialState: ExtraChargeSubjectState = {
    ExtraChargeSubject: {} as ExtraChargeSubjectModel,
    ExtraChargeSubjectList: [],
}

export const IExtraChargeSubjectSlice = createSlice({
    name: 'extraChargeSubject',
    initialState,
    reducers: {
        setExtraChargeSubject: (state, action: PayloadAction<ExtraChargeSubjectModel[]>) => {
            state.ExtraChargeSubjectList = action.payload
        },
        saveExtraChargeSubject: (state, action: PayloadAction<ExtraChargeSubjectModel>) => {
            let room = action.payload
            if (room.Id > 0) {
                let defaultModel: ExtraChargeSubjectModel = { Id: 0, SubjectName: room.SubjectName }
                let currentRoom =
                    state.ExtraChargeSubjectList.find((c) => c.Id === room.Id) || defaultModel
                    currentRoom.SubjectName = room.SubjectName
                   
            } else {
                room.Id = (Math.max(...state.ExtraChargeSubjectList.map((c) => c.Id)) || 0) + 1
                state.ExtraChargeSubjectList.push(room)
            }
        },
        getExtraChargeSubjectById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let ExtraChargeSubject: ExtraChargeSubjectModel = {} as ExtraChargeSubjectModel
            if (id > 0) {
                let currentExtraChargeSubject: ExtraChargeSubjectModel[] = state.ExtraChargeSubjectList
                ExtraChargeSubject = currentExtraChargeSubject.find((c) => c.Id === id) || ({} as ExtraChargeSubjectModel)
            }

            state.ExtraChargeSubject = ExtraChargeSubject
        },
        deleteExtraChargeSubject: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentExtraChargeSubject: ExtraChargeSubjectModel[] = state.ExtraChargeSubjectList
                state.ExtraChargeSubjectList = currentExtraChargeSubject.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setExtraChargeSubject, saveExtraChargeSubject, getExtraChargeSubjectById, deleteExtraChargeSubject } =
IExtraChargeSubjectSlice.actions

export default IExtraChargeSubjectSlice.reducer
